'use client';

import { usePathname } from 'next/navigation';
import { useCallback } from 'react';
import { useStore } from 'zustand';

import { cartStore, closeCart } from '@/store/cart/cart.store';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { AddMoreProceduresDestination } from '@/types/enums/analytics/cart/cart-analytics.enum';
import { trackAddMoreProcedures } from '@/utils/cart/cart-analytics.util';

export interface UseCartNavigationResult {
  addProcedure: () => void;
  goToSearch: () => void;
}

export function useCartNavigation(): UseCartNavigationResult {
  const pathname = usePathname();
  const cart = useStore(cartStore, (state) => state.cart);
  const origin = useStore(cartStore, (state) => state.origin);

  const isOnSearchResults = pathname?.startsWith('/busca/') ?? false;

  const addProcedure = useCallback(() => {
    const destination = isOnSearchResults
      ? AddMoreProceduresDestination.CLOSED_MODAL
      : AddMoreProceduresDestination.SEARCH;

    trackAddMoreProcedures(origin, cart?.items ?? [], destination);

    closeCart();

    if (!isOnSearchResults) {
      handleOpenSearchModal();
    }
  }, [cart, isOnSearchResults, origin]);

  const goToSearch = useCallback(() => {
    closeCart();
    handleOpenSearchModal();
  }, []);

  return { addProcedure, goToSearch };
}
